import React from 'react';

export const Disconnect = () => {
  return (
    <div className="flex flex-column items-center">
      <div className="text-white flex flex-column items-center md:max-w-[70%] text-center gap-4">
        <h1 className="text-6xl font-['Sharp Grotesk'] font-medium m-0 mt-[4rem] md:mt-[8rem]">
          QuickBooks Disconnected
        </h1>
        <p className="max-w-[40rem] leading-6 font-light m-0">
          Your QuickBooks Integration has been disconnected. Invoices and payments from Quipli will no longer be synced
          to QuickBooks Online.
        </p>
        <p className="max-w-[40rem] leading-6 font-light m-0">
          To reconnect log into Quipli, navigate to Accounting -&gt; QuickBooks Online Setup, and Connect to QuickBooks.
        </p>
      </div>
      <picture className="m-4 md:m-16">
        <source
          media="(min-width: 768px)"
          srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.webp"
        />
        <source
          media="(min-width: 768px)"
          srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.png"
        />
        <source srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental-mob.webp" />
        <source srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental-mob.png" />
        <img
          className="max-w-full h-[auto]"
          src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.png"
          alt="Rental Software"
          decoding="async"
          width="1691"
          height="1063"
        />
      </picture>
    </div>
  );
};
